import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { MBCChatPage } from "@/features/request/mbc-chat";
import { requireMbcFeatureFlag } from "@/lib/posthog-flags";

const mbcSearchSchema = z.object({
  brandId: z.coerce.number().optional(),
  designType: z.coerce.number().optional(),
  ["project-id"]: z.coerce.number().optional(),
  ["request-type"]: z
    .enum(["video", "graphic", "website_design", "website_implementation"])
    .optional(),
  resourceId: z.string().optional(),
  threadId: z.string().optional(),
});

export const Route = createFileRoute("/_auth/_app-shell/requests/mbc")({
  beforeLoad: requireMbcFeatureFlag,
  component: RouteComponent,
  validateSearch: mbcSearchSchema,
});

function RouteComponent() {
  const {
    brandId,
    designType,
    ["project-id"]: projectId,
    ["request-type"]: requestType,
    resourceId,
    threadId,
  } = Route.useSearch();

  return (
    <MBCChatPage
      designType={designType}
      projectId={projectId}
      requestType={requestType}
      resumeBrandId={brandId}
      resumeResourceId={resourceId}
      resumeThreadId={threadId}
    />
  );
}
